import Param from '../../param';
import Util from '../../util';
import effectManager from '../effect';
import Pararax from './pararax';
import Fixed from './fixed';
import ScrollAnimation from './scrollanimation';
import Contents from './contents';

let pararax;
let fixed;
let scrollAnimation;
let util = new Util();


export default class smoothScrollManager{
    constructor(inc){

        pararax = new Pararax();
        scrollAnimation = new ScrollAnimation();
        fixed = new Fixed();
        this.contents = new Contents();
        // contents = new Contents();

        this.w;
        this.h;
        this.hHalf;

        this.pageID;

        this.$root;
        this.$bodyTag;
        this.$container;
        this.$body;
        /* 臨時 */
        this.$bodyContents;
        this.$kv; // [ KVアニメーション用 ]
        this.$topAbout; //[ TOP用 aboutセンテンス ]
        this.$topAboutStage; //[ TOP用 aboutイメージの高さ ]
        this.$banner; //android banner

        this.$prarax;
        this.$target;
        this.$scrollDown;


        this.flg = false;


        this.inc = 0;
        this.nowInc = 0;
        this.prevInc = 0;
        this.dir = "next";
        this.add = 0.1;

        this.paraPoint = [];

        this.scrollLimit = 0; // scroll limit

        this.timer = [];

        this.type = "normal";

        this.inertia = (Useragnt.mobile||Useragnt.tablet||Useragnt.safari)?false:false; /* 慣性スクロールを有効にするか */


        /* 状態監視用のフラグ */
        this.status = {
            controll : false, /* ページャーなどで操作しているか */
            comp     : false, /* 慣性スクロールが完了したか */
            init     : false, /* 初回の処理がされているか */
            about    : {
                type : "show",
                point: 0,
                endPoint:0,
                h : 0, // センテンスの高さ
                objH : 0, // aboutイラストの高さ
                breakPoint :0
            },
            mode : "normal",//[ normal:ボディをスクロール制御 // select:指定したidをスクロール制御 ]
            temp : {//前回の状態保存。modeを切り替える際に使用する
                inc : 0,
                nowInc:0,
                prevInc:0,
                dir : "",
            }
        }

        this.topFlg = {
            next:false,
            prev:false,
        }; //一定のスクロール量でボディ、KVに移動するように管理


        this.renderTime = 0


    }
    init(pageID){

        this.pageID = pageID;
        this.contents.init();

        this.$root = document.getElementById("l-root");
        this.$bodyTag = document.getElementsByTagName('body');
        this.$container = document.getElementById("l-scroll");
        this.$body = document.getElementById("l-scroll-body");
        /* 臨時 */
        this.$bodyContents = document.getElementsByClassName("l-root-load");
        this.$kv = document.getElementById("l-kv"); // [ KVアニメーション用 ]
        this.$scrollDown = document.getElementById("c-scrolldown");
        this.$banner = document.getElementById("c-android-banner");

        this.$topAbout = this.pageID=="top" ? document.getElementById("p-about"):false;
        //p-about-stage
        this.$topAboutStage = this.pageID=="top" ? document.getElementById("p-about-stage"):false;

        // pager.init();
        pararax.init(this.h);
        scrollAnimation.init();

        // TweenLite.to(window, 0.1,{scrollTo:{y:0,autoKill:false}});
        this.$kv.classList.remove("is-fit");
        this.$kv.classList.remove("is-start");

        document.getElementById("c-pagetop").addEventListener("click",(e)=>{
            // window.scroll(0,0)
            e.stopPropagation();
            this.to(0);
        });
        document.getElementById("l-footer-pagetop").addEventListener("click",(e)=>{
            e.stopPropagation();
            this.to(0);
            // window.scroll(0,0)
        });

        if(this.status.init) return;
        this.status.init = true;

        this.to(0);
        fixed.init(this.h);
        if(!this.inertia) this.$bodyTag[0].classList.add('is-inertia-none');


    }
    to(inc){

        TweenLite.to(window, 0.1, {
            scrollTo:{y:inc,autoKill:false},
            onComplete:()=>{
                // this.$body

                // if(inc==0) TweenLite.to([this.$body,this.$kv], 0.1, {
                //     y:0,
                //     delay:1,
                //     onComplete:()=>{
                //         this.reset();
                //     }
                // });


            }
        });
    }
    toFast(inc){

        TweenLite.to(window, 0.001, {
            scrollTo:{y:inc,autoKill:false}
        });

    }
    reset(){
        // console.log("scroll reset")
        this.to(0);
        this.update(0,"prev");
        this.nowInc = 0;
        this.add = 1; // 一瞬イージングなし
        this.trans();
        this.add = 0.1; // イージング戻す
    }
    changeMode(select,$body) {


        if (select == "normal") {
            this.$body = document.getElementById("l-scroll-body");

        } else {
            // this.$body = document.getElementById("l-scroll-body");
            this.$body = $body;
        }

        if (select == "normal") {
            this.inc = this.status.temp.inc;
            this.nowInc = this.status.temp.nowInc;
            this.prevInc = this.status.temp.prevInc;
            this.dir = this.status.temp.dir;
            this.resize(window.innerWidth, window.innerHeight);
            this.status.mode = select;
            this.toFast(this.inc);
        } else {
            this.status.mode = select;
            this.status.temp.inc = this.inc;
            this.status.temp.nowInc = this.nowInc;
            this.status.temp.prevInc = this.prevInc;
            this.status.temp.dir = this.dir;
            this.resize(window.innerWidth, window.innerHeight);
            this.reset();
        }
    }

    update(inc,dir){ /* スクロール方向を決めうちしないならdirは空で渡してください */
        this.inc = inc;
        this.dir = (dir==="")?(this.inc>this.prevInc)?"next":"prev":dir;
        // this.prevInc = this.inc;
        this.mode = "scroll";
        this.status.comp = false;



    }
    move(fpsRate,bannerShow) {

        if(this.inc==undefined) return;
        this.nowInc += this.add * (this.inc - this.nowInc)*fpsRate;

        // this.nowInc = (this.nowInc>=0)?Math.floor(this.nowInc*10 )/10:0;



        this.trans(bannerShow);

    }
    trans(bannerShow) {

        if(this.inertia){
            this.$body.style.transform = 'translateY(-'+ this.nowInc +'px)'
        }
        /* スクロール連動で動作 */
        pararax.check(this.nowInc,this.dir);

        // pager.update(this.nowInc,this.dir,this.h);
        this.contents.update(this.nowInc,this.pageID,bannerShow);

        /* アニメーション対象の要素があるかチェック */
        scrollAnimation.check(
            this.nowInc,
            false,
        );


        /* TOP KVのイラスト（サービス）動作制御 */

        // if(this.pageID==="top"){
        //     fixed.check(this.nowInc,this.dir,"js__filter-"+this.pageID);
        // }else{
        //     fixed.check(this.nowInc,this.dir,"");
        // }

        if(this.pageID==="top"){ // TOP KVのスクロール制御


            if(this.status.about.point < this.inc && this.status.about.endPoint > this.inc ){
                this.$kv.style.transform = 'translateY(-'+ (this.inc-this.status.about.breakPoint) +'px)'
                // TweenMax.to(this.$kv, 0.8, {
                //     y : -window.innerHeight,
                //     // y:'-'+ (this.inc-this.status.about.breakPoint) +'px',
                // });

            }

            this.renderTime += 1
            if(this.renderTime<20) return
            this.renderTime = 0

            if(10<this.inc){
                if(!this.topFlg.next&&this.dir=="next"){
                    this.topFlg.next = true;
                    this.topFlg.prev = false;

                    this.$kv.classList.add("is-start");
                    this.$bodyContents[0].classList.add("is-view");
                    this.$kv.classList.add("is-fit");

                    fixed.animation("out","js__filter-"+this.pageID);
                }
            }else{


                if(window.innerHeight>this.inc){
                    if(!this.topFlg.prev&&this.dir=="prev"){
                        this.topFlg.prev = true;
                        this.topFlg.next = false;

                        if(this.status.mode == 'normal'){
                            this.$bodyContents[0].classList.remove("is-view");
                            this.$kv.classList.remove("is-start");
                            this.$kv.classList.remove("is-fit");
                            if(this.inc<=1) this.$kv.style.transform = 'translateY(0px)'
                        }

                        fixed.animation("show","js__filter-"+this.pageID);
                        this.$kv.style.transform = 'translateY(-'+ 0 +'px)'
                    }
                }
            }
            if(this.status.about.endPoint < this.inc){
                TweenMax.set(this.$kv, {
                    opacity:0
                });
            } else {
                TweenMax.set(this.$kv, {
                    opacity:1
                });
            }


        }else{
            this.$kv.style.transform = 'translateY(-'+ this.inc +'px)'
            // TweenMax.to(this.$kv, 1, {
            //     y:-(this.inc) +'px',
            // });
        }




        /* TOP KVのイラスト（サービス）動作制御 END */
        if(
            this.prevInc>this.nowInc-0.1&&this.dir=="next" ||
            this.prevInc<this.nowInc+0.1&&this.dir=="prev"
        ){
            this.onComplete();
        }
        this.prevInc = this.nowInc;
    }

    resize (display) {
        if(this.$root.classList.contains("is-modal-open")) return;
        this.w = window.innerWidth;
        this.h = window.innerHeight;
        this.hHalf = this.h/2;

        this.$root.style.height = this.$body.clientHeight+'px';

        if(this.$topAbout){
            let _aboutRect = this.$topAbout.getBoundingClientRect();

            this.status.about.objH = this.$topAboutStage.getBoundingClientRect().height;

            this.status.about.h = _aboutRect.height;
            this.status.about.point = _aboutRect.top + this.inc;
            this.status.about.endPoint = this.status.about.point + this.status.about.h + this.h;

            this.status.about.breakPoint = display=="pc"?this.status.about.point+this.status.about.h/2-this.status.about.objH/2:this.status.about.point+this.w*0.2;

            // this.status.about.h = this.$topAbout.clientHeight;
            // this.status.about.point = display=="pc"?_aboutRect.top + this.status.about.h/2.5:_aboutRect.top + this.inc + this.status.about.h/2;
        }

        pararax.resize(this.h,display);
        fixed.resize(this.h,display);
        scrollAnimation.resize(this.h);
        this.contents.resize(this.h);
    }

    /* -------------------------------------------

      -- Callback

    ------------------------------------------- */

    onComplete(){ /* スクロール動作が終わったら */
        // this.status.comp = true;
        // if(this.inc==0){
        //     this.topFlg=false;
        // }else{
        //     this.topFlg=true;
        // }
        if(this.dir=="prev") this.topFlg.next = false;
        if(this.dir=="next") this.topFlg.prev = false;
    }

    /* -------------------------------------------

      -- ステータスいじいじするやつ

    ------------------------------------------- */

    datGUI(){

    }
}